import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { TRANSLATIONS } from "../../../constants/translations.constants";

export const EditContentDialog = ({
  editContent,
  handleCancel,
  commodityInfo,
  handleEditContentChange,
  handleEditContentSave,
}) => {
  const headerContent = (
    <div className='p-0 m-0'>
      <p className='text-2xl p-0 m-0'>Change to Previous Close</p>
    </div>
  );

  const footerContent = (
    <div className='flex justify-content-end flex-wrap gap-5'>
      <div>
        <Button label='Cancel' className='p-button p-button-sm diag-discard-button' onClick={handleCancel} />
      </div>
      <div>
        <Button label='Save' onClick={handleEditContentSave} className='p-button p-button-sm diag-save-button' />
      </div>
    </div>
  );

  return (
    <Dialog
      baseZIndex={10001}
      className='diag1'
      visible={editContent}
      style={{ width: "800px" }}
      onHide={handleCancel}
      focusOnShow={false}
      footer={footerContent}
      header={headerContent}
    >
      <div className='diag-box'>
        <div className='grid'>
          {commodityInfo.length > 0 &&
            commodityInfo.map((arrayValue, index) => (
              <div className={`col-5 ${index % 2 === 1 ? "col-offset-2" : "pl-3"}`} key={index}>
                <div className='col-12 p-0 diag-syndication mt-5'>{commodityInfo[index].commodity}</div>
                <div className='col-10 pl-0'>
                  <InputText
                    value={arrayValue.percentageChangeValue}
                    onChange={(event) => handleEditContentChange(event, index)}
                    className='widthFull'
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </Dialog>
  );
};
